import React, { useState } from "react";
import { Icon, SecondaryButton } from "@prestosports/commons-ui";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Printer32 from "@carbon/icons-react/lib/printer/32";
import { SportCodes } from "@prestosports/prestostats-core/Common";
import { useEventContext } from "../../../../state/events/context";
import FootballPrint from "./football/FootballPrint";

const PrintButton = ({ setIsLoading, isLoading }) => {
	const { state: eventState } = useEventContext();
	const currentEvent = eventState.currentEvent();
	const { sportId } = currentEvent || {};
	const [dialogOpen, setDialogOpen] = useState(false);

	const handleDialogClose = () => {
		setIsLoading(false);
		setDialogOpen(false);
	};

	return (
		<>
			<SecondaryButton
				id="button-print"
				disabled={isLoading}
				padding={4}
				onClick={() => setDialogOpen(true)}
				label="Print"
				startIcon={
					<Icon>
						<Printer32 />
					</Icon>
				}
			/>

			<Dialog open={dialogOpen} onClose={handleDialogClose}>
				<DialogTitle id="download-report-title">Print</DialogTitle>
				<DialogContent>
					{(sportId === SportCodes.Football ||
						sportId === SportCodes.FlagFootball) && (
						<FootballPrint isLoading={isLoading} setIsLoading={setIsLoading} />
					)}
				</DialogContent>
				<DialogActions>
					<SecondaryButton label="Close" onClick={handleDialogClose} size="medium" />
				</DialogActions>
			</Dialog>
		</>
	);
};

export default PrintButton;
